import React, { useContext, useEffect, useRef, useState } from 'react'
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { UserContext } from '../../App';
import { ConfirmOrRefund, SuccesBuy } from '../../components/dashboard/alert';
import { LoadingFull } from '../../components/loading';
import { OrderDetails } from '../../components/dashboard/confirmation/orderDetails';
import { BookOverview } from '../../components/dashboard/boughtBook/bookOverview';

const Confirmation = () => {

  const [data, setData] = useState();
  const [reloadData, setReloadData] = useState(false);
  const navigate = useNavigate()
  const { auth, user, showModal, setShowModal } = useContext(UserContext)
  const token = localStorage.getItem('token')
  const [searchParams, setSearchParams] = useSearchParams();
  const isFirstRender = useRef(true);
  
  useEffect(() => {
    if (!showModal && !auth && !isFirstRender.current) {
      navigate('/')
      return;
    }
    if (isFirstRender.current) {
      isFirstRender.current = false;
    }
    if (!auth) {
      setShowModal(true)
    } else {
      axios({
        method: 'post',
        url: '/api/orderDetails',
        data: {
          'dbId': searchParams.get("order")
        },
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        setData(response.data);
      })
      .catch(error => {
        navigate('/')
      });
    }
  }, [auth, user, reloadData, showModal]);

  return (
    <div className="relative innerContainer mx-auto py-[104px] md:py-[106px] min-h-lvh">
      {(typeof data === 'undefined') ?
        <div className="min-h-lvh items-center flex">
          <LoadingFull />
        </div>
      :
        <div className="w-full">
          <div className="flex flex-col gap-8 h-full justify-between">
            <div className="h-full flex flex-col gap-y-5 justify-between">
              {(searchParams.get("success") === "true") ?
                <SuccesBuy data={data} />
              :
                ""}
              <div className="flex gap-5 flex-col md:flex-row h-full">
                <OrderDetails data={data} />
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  )
}


export default Confirmation;